var _rect, _rect2, _g, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicOffIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 1.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7499_204531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.66895,
    y: 2.66797,
    width: 19.6614,
    height: 19.6614,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7499_204531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9349 20L16.8574 17.9225C16.294 18.2981 15.6868 18.5857 15.0356 18.7852C14.3839 18.9847 13.6943 19.0845 12.9666 19.0845C11.9924 19.0845 11.0769 18.8995 10.2201 18.5296C9.36328 18.1601 8.61797 17.6585 7.98417 17.0246C7.35037 16.3908 6.84872 15.6455 6.47924 14.7887C6.10929 13.9319 5.92431 13.0164 5.92431 12.0423C5.92431 11.3146 6.02407 10.6249 6.22361 9.97324C6.42314 9.32207 6.71069 8.71479 7.08628 8.15141L4.99121 6.05634L5.99473 5.05282L19.9384 18.9965L18.9349 20ZM12.2623 17.6408V16.2676C11.875 16.2676 11.5436 16.1298 11.268 15.8542C10.9919 15.5782 10.8539 15.2465 10.8539 14.8592V14.1549L7.47361 10.7746C7.43839 10.9859 7.406 11.1972 7.37642 11.4085C7.34731 11.6197 7.33276 11.831 7.33276 12.0423C7.33276 13.4624 7.79943 14.7066 8.73276 15.7746C9.66562 16.8427 10.8421 17.4648 12.2623 17.6408ZM18.8468 15.8979L17.8257 14.8768C18.0722 14.4425 18.2628 13.9876 18.3975 13.512C18.5328 13.0369 18.6004 12.5469 18.6004 12.0423C18.6004 10.892 18.2806 9.84155 17.6412 8.89085C17.0013 7.94014 16.1473 7.25352 15.0792 6.83099V7.11268C15.0792 7.5 14.9414 7.83146 14.6659 8.10704C14.3898 8.3831 14.0581 8.52113 13.6708 8.52113H12.2623V9.31338L9.11093 6.16197C9.67431 5.79812 10.2788 5.51362 10.9243 5.30845C11.5698 5.10282 12.2506 5 12.9666 5C13.9407 5 14.8562 5.18474 15.713 5.55423C16.5698 5.92418 17.3152 6.42606 17.949 7.05986C18.5828 7.69366 19.0844 8.43897 19.4539 9.29577C19.8238 10.1526 20.0088 11.0681 20.0088 12.0423C20.0088 12.7582 19.906 13.439 19.7004 14.0845C19.4952 14.73 19.2107 15.3345 18.8468 15.8979Z",
    fill: "#959595"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 1.5,
    stroke: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicOffIconImage);
export default __webpack_public_path__ + "static/media/PublicOffIconImage.ade82c968086e50c52e1c0eb98e1ba58.svg";
export { ForwardRef as ReactComponent };